module.exports = __webpack_public_path__ + "static/media/stepperDown.113a6dc4.svg";